<template>
  <Modal :id="id" title="Event Attendance">
    <div slot="body" class="modal-body">
      <p class="text-center">
        It's time to take attendance!<br />
        Press the button provided to record attendance for this event.
      </p>
    </div>
    <div slot="footer" class="modal-footer">
      <div class="col-12 text-center">
        <a
          class="btn btn-warning"
          :href="route('admin.events.enrollments.attendance', routeParam)"
          >Edit Attendance</a
        >
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "attendance-notice-modal",
      event: null,
    };
  },
  computed: {
    routeParam() {
      return { event: this.event.id };
    },
  },
  created() {
    this.event = _.cloneDeep(this.options.event);
  },
};
</script>
